export type FormStatus = "Edit" | "Add" | "";
export type ButtonAction = "Save" | "Close" | "";
export const LocalStorageKey = {
  UserInfo: "UserInfo",
};
export const Role = {
  comadmin: "comadmin",
  sysadmin: "sysadmin",
};
